module.exports = __webpack_public_path__ + "static/bg03-f77972ba2e96bd96934b9beba09117f9.png";